import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function CallbackPage() {
    const navigate = useNavigate()

    // useEffect(() => {
    //     debugger
    //     const params = new URLSearchParams(window.location.search);
    //     const token = params.get("token");
    //     if (params) {

    //         fetch("https://devapi2.kpostindia.com/v2/profile/getUserProfile/", {
    //             method: "GET",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         })
    //             .then(res => res.json())
    //             .then(data => {
    //                 if (data.status.toLowerCase() === "success") {
    //                     // Assuming data contains user profile information
    //                     console.log("User profile data:", data);
    //                     // Save user session locally (e.g., context, localStorage)
    //                     localStorage.setItem("accessToken", token);
    //                     localStorage.setItem("AuthUser", JSON.stringify(data.data));
    //                     localStorage.setItem("companyID", data.data.companyID);
    //                     localStorage.setItem("coreui-free-react-admin-template-theme", "light")
    //                     // Remove token from URL
    //                     const newParams = new URLSearchParams(window.location.search);
    //                     newParams.delete("token");

    //                     const newUrl =
    //                         window.location.pathname +
    //                         (newParams.toString() ? `?${newParams.toString()}` : "");

    //                     window.history.replaceState({}, "", newUrl);
    //                 } else {
    //                     // alert("Invalid or expired token");
    //                 }
    //             });
    //     }
    // }, []);

    useEffect(() => {
        const extractCode = () => {
            // const hashParams = new URLSearchParams(window.location.hash.substring(1));
            const queryParams = new URLSearchParams(window.location.search);
            const authCode = queryParams.get('token')

            console.log('Callback URL:', window.location.href)
            console.log('Extracted Code:', authCode)

            if (authCode) {
                localStorage.setItem('accessToken', authCode)
                console.log('Auth token saved:', authCode)
                fetchLoginDetails(authCode)
            }
        }

        extractCode()
    }, [])

    const fetchLoginDetails = async (token) => {
        debugger
        try {
            const response = await fetch('https://devapi2.kpostindia.com/v2/profile/getUserProfile/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`)
            }

            const data = await response.json()
            console.log('User Login Details:', data)

            localStorage.setItem("accessToken", token);
            localStorage.setItem("AuthUser", JSON.stringify(data.data));
            localStorage.setItem("companyID", data.data.companyID);
            navigate('/dashboard', { replace: true })
            // const newParams = new URLSearchParams(window.location.search);
            // newParams.delete("token");

            // const newUrl =
            //     window.location.pathname +
            //     (newParams.toString() ? `?${newParams.toString()}` : "");

            // window.history.replaceState({}, "", newUrl);
        } catch (error) {
            console.error('Error fetching login details:', error)
            navigate('/')
        }
    }

    return <h2>Logging in...</h2>
}

export default CallbackPage
